import React, { useEffect, useState } from 'react';
import { URL } from '../variables';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../Header';
import Aside from '../SideBar/Aside';

import '../SideBar/styles/App.scss';
import { mudarDados } from '../actions/AppActions';
import { Link, Redirect, Route, Switch } from 'react-router-dom';

import Request from '../Request';
import Faculdades from './Faculdades/Faculdades';
import CriarFaculdade from './Faculdades/CriarFaculdade';
import EditarFaculdade from './Faculdades/EditarFaculdade';
import ShowFaculdade from './Faculdades/ShowFaculdade';
import Dashboard from './Faculdades/Dashboard';
import CriarProcesso from './Processo/CriarProcesso';
import EditarProcesso from './Processo/EditarProcesso';
import CriarCorretor from './Corretores/CriarCorretor';
import EditarCorretor from './Corretores/EditarCorretor';
import CriarFiscal from './Fiscais/CriarFiscal';
import EditarFiscal from './Fiscais/EditarFiscal';
import CriarAluno from './Alunos/CriarAluno';
import EditarAluno from './Alunos/EditarAluno';
import CategoriasQuestoes from './CategoriasQuestoes/CategoriasQuestoes';
import CriarCategoria from './CategoriasQuestoes/CriarCategoria';
import EditarCategoria from './CategoriasQuestoes/EditarCategoria';
import Questoes from './CategoriasQuestoes/Questoes';
import CriarQuestao from './CategoriasQuestoes/CriarQuestao';
import EditarQuestao from './CategoriasQuestoes/EditarQuestao';
import ChatBotQuestao from './CategoriasQuestoes/ChatBotQuestao';

import BancaQuestoes from './BancaQuestoes/BancaQuestoes';

import ShowProcesso from './Processo/ShowProcesso';
import CriarRedacao from './Redacoes/CriarRedacao';
import EditarRedacao from './Redacoes/EditarRedacao';
import CriarProva from './Provas/CriarProva';
import EditarProva from './Provas/EditarProva';
import CriarCandidatoVinculado from './CandidatosVinculados/CriarCandidatoVinculado';
import CriarFiscalVinculado from './FiscaisVinculados/CriarFiscalVinculado';
import CriarCorretorVinculado from './CorretoresVinculados/CriarCorretorVinculado';
import ShowSala from './SalasProcesso/ShowSala';
import ShowRedacoesProcesso from './RedacoesProcesso/ShowRedacoesProcesso';
import ShowProvasProcesso from './ProvasProcesso/ShowProvasProcesso';
import ShowCandidato from './CandidatosVinculados/ShowCandidato';
import EditarCandidatoConflito from './CandidatosConflitos/EditarCandidatoConflito';
import ShowAnalise from './AnalisesCandidatos/ShowAnalise';
import CriarProvaExistente from './Provas/CriarProvaExistente';

import Questionarios from './Questionarios/Questionarios';
import CriarQuestionario from './Questionarios/CriarQuestionario';
import EditarQuestionario from './Questionarios/EditarQuestionario';
import CriarQuestionarioVinculado from './QuestionariosVinculados/CriarQuestionarioVinculado';
import ShowQuestionarioProcesso from './QuestionariosVinculados/ShowQuestionarioProcesso';
import Professores from './Professores/Professores';
import CriarProfessor from './Professores/CriarProfessor';
import EditarProfessor from './Professores/EditarProfessor';
import Demandas from './Demandas/Demandas';
import CriarDemanda from './Demandas/CriarDemanda';
import EditarDemanda from './Demandas/EditarDemanda';
import ShowDemanda from './Demandas/ShowDemanda';

import Conteudos from './Conteudos/Conteudos';
import CriarConteudo from './Conteudos/CriarConteudo';
import EditarConteudo from './Conteudos/EditarConteudo';
import ShowConteudo from './Conteudos/ShowConteudo';
import CriarQuestaoConteudo from './Conteudos/CriarQuestaoConteudo';
import EditarQuestaoConteudo from './Conteudos/EditarQuestaoConteudo';

import CriarAtribuicoes from './Demandas/CriarAtribuicoes';
import Recursos from './Recursos/Recursos';
import CriarRecurso from './Recursos/CriarRecurso';
import EditarRecurso from './Recursos/EditarRecurso';
import ShowRecurso from './Recursos/ShowRecurso';
import QuestoesDemanda from './Demandas/QuestoesDemanda';
import CriarDiagramacao from './Diagramacoes/CriarDiagramacao';
import EditarDiagramacao from './Diagramacoes/EditarDiagramacao';
import Clientes from './Clientes/Clientes';
import CriarCliente from './Clientes/CriarCliente';
import EditarCliente from './Clientes/EditarCliente';
import EditProfile from './EditProfile/EditProfile';
import ShowAnaliseObjeto from './AnalisesCandidatosObjetos/ShowAnaliseObjeto';
import CriarOrganizadora from './Organizadoras/CriarOrganizadora';


import Organizadoras from './Organizadoras/Organizadoras';
import EditarOrganizadora from './Organizadoras/EditarOrganizadora';
import Membros from './Membros/Membros';
import CriarMembro from './Membros/CriarMembro';
import EditarMembro from './Membros/EditarMembro';
import CriarAtribuicoesRedacao from './Demandas/CriarAtribuicoesRedacao';
import ShowDiagramacao from './Diagramacoes/ShowDiagramacao';
import CriarAvaliador from './Avaliador/CriarAvaliador';
import EditarAvaliador from './Avaliador/EditarAvaliador';
import CriarAvaliadorVinculado from './AvaliadoresVinculados/CriarAvaliadorVinculado';
import CriarEntrevista from './Entrevista/CriarEntrevista';
import EditarEntrevista from './Entrevista/EditarEntrevista';
import ShowEntrevista from './Entrevista/ShowEntrevista';
import ModulosSistema from './ModulosSistema/ModulosSistema';
import Redacao from './RedacoesProcesso/Redacao';
import { CircularProgress } from '@material-ui/core';
import Modulos from './Modulos/Modulos';
import CriarModulo from './Modulos/CriarModulo';
import EditarModulo from './Modulos/EditarModulo';
import ShowModulo from './Modulos/ShowModulo';
import Treinamentos from './Treinamentos/Treinamentos';
import CriarTreinamento from './Treinamentos/CriarTreinamento';
import VincularInstituicao from './Treinamentos/VincularInstituicao';
import EditarTreinamento from './Treinamentos/EditarTreinamento';
import ShowTreinamento from './Treinamentos/ShowTreinamento';

import DashboardTreinamento from './Treinamentos/DashboardTreinamento';

import AvaliarQuestoes from './Recursos/AvaliarQuestoes';
import ShowAvaliarQuestoes from './Recursos/ShowAvaliarQuestoes';
import Diagramacoes from './Diagramacoes/Diagramacoes';
import './home.css';
import { usePreferences } from '../contexts/PreferencesContext';

const getEntityLabels = (user, t = (key) => key) => {
  const changedText = user?.empresa?.change_text === true;
  return {
    institution: changedText ? t('process') : t('organization'),
    institutions: changedText ? t('processes') : t('organizations'),
    process: changedText ? t('vacancy') : t('process'),
    processes: changedText ? t('vacancies') : t('processes')
  };
};

const getBreadcrumbLabels = (user, t = (key) => key) => {
  const entities = getEntityLabels(user, t);
  return {
    instituicao: entities.institutions,
    processos: entities.processes,
    processo: entities.process,
    register: t('register'),
    edit: t('edit'),
    show: t('details'),
    link: t('link'),
    dashboard: t('dashboard'),
    corretores: t('graders'),
    fiscais: t('proctors'),
    avaliadores: t('evaluators'),
    candidatos: t('candidates'),
    questionarios: t('questionnaires'),
    questionarios_vinculados: t('linkedQuestionnaires'),
    elaboradores: t('authors'),
    edit_profile: t('myProfile'),
    membros: t('members'),
    organizadoras: t('organizers'),
    demandas: t('demands'),
    atribuicoes: t('assignments'),
    register_redacoes: t('essays'),
    conteudos: t('contents'),
    conteudo: t('content'),
    questao: t('question'),
    modulos: t('modules'),
    modulo: t('module'),
    treinamentos: t('trainings'),
    treinamento: t('training'),
    redacoes: t('essays'),
    recursos: t('resources'),
    'avaliar-questoes': t('evaluateQuestions'),
    disciplinas: t('disciplines'),
    questoes: t('questions'),
    chatbot: t('ui_criar_questao_com_ia_e87441a1'),
    'banca-questoes': t('questionBank'),
    provas: t('tests'),
    register_existing: t('importExisting'),
    entrevistas: t('interviews'),
    diagramacoes: t('diagramLayouts'),
    salas: t('rooms'),
    system: t('system'),
    candidatos_errors: t('candidateConflicts'),
    show_analises: t('analyses'),
    show_analises_objetos: t('analysisObjects'),
    ...entities
  };
};

const breadcrumbResourceConfig = {
  faculdade: {
    path: (id) => `faculdade/get_faculdade/${id}`,
    pick: (response) => response?.faculdade
  },
  processo: {
    path: (id) => `faculdade/get_processo/${id}`,
    pick: (response) => response?.processo
  },
  corretor: {
    path: (id) => `faculdade/get_corretor/${id}`,
    pick: (response) => response?.corretor
  },
  fiscal: {
    path: (id) => `faculdade/get_fiscal/${id}`,
    pick: (response) => response?.fiscal
  },
  avaliador: {
    path: (id) => `faculdade/get_avaliador/${id}`,
    pick: (response) => response?.avaliador
  },
  candidato: {
    path: (id) => `faculdade/get_candidato/${id}`,
    pick: (response) => response?.aluno || response?.candidato
  },
  candidatoConflito: {
    path: (id) => `faculdade/get_candidato_error/${id}`,
    pick: (response) => response?.aluno || response?.candidato
  },
  professor: {
    path: (id) => `faculdade/get_professor/${id}`,
    pick: (response) => response?.professor
  },
  questionario: {
    path: (id) => `faculdade/get_questionario/${id}`,
    pick: (response) => response?.questionario
  },
  categoria: {
    path: (id) => `faculdade/get_categoria/${id}`,
    pick: (response) => response?.categoria
  },
  questao: {
    path: (id) => `faculdade/get_questao/${id}`,
    pick: (response) => response?.questao
  },
  prova: {
    path: (id) => [`faculdade/get_prova/${id}`, `faculdade/get_prova_processo/${id}`],
    pick: (response) => response?.prova
  },
  redacao: {
    path: (id) => [`faculdade/get_redacao/${id}`, `faculdade/get_redacao_processo/${id}`],
    pick: (response) => response?.redacao
  },
  entrevista: {
    path: (id) => `faculdade/get_entrevista/${id}?show=1`,
    pick: (response) => response?.entrevista
  },
  diagramacao: {
    path: (id) => `faculdade/get_diagramacao/${id}?show=1`,
    pick: (response) => response?.diagramacao ? {
      ...response.diagramacao,
      processo: response.processo || response.diagramacao.processo,
      faculdade: response.processo?.faculdade || response.diagramacao.faculdade
    } : null
  },
  sala: {
    path: (id) => `faculdade/get_sala/${id}`,
    pick: (response) => response?.sala
  },
  demanda: {
    path: (id) => `faculdade/get_demanda/${id}`,
    pick: (response) => response?.demanda
  },
  recurso: {
    path: (id) => `faculdade/get_recurso/${id}`,
    pick: (response) => response?.recurso
  },
  conteudo: {
    path: (id) => `conteudo/get_content/${id}`,
    pick: (response) => response?.data
  },
  modulo: {
    path: (id) => `modulo/get_module/${id}`,
    pick: (response) => response?.module
  },
  treinamento: {
    path: (id) => `treinamento/get_training/${id}`,
    pick: (response) => response?.data
  },
  membro: {
    path: (id) => `faculdade/get_membro/${id}`,
    pick: (response) => response?.membro
  },
  organizadora: {
    path: (id) => `faculdade/get_organizadora/${id}`,
    pick: (response) => response?.organizadora || response?.empresa
  },
  cliente: {
    path: (id) => `faculdade/get_cliente/${id}`,
    pick: (response) => response?.cliente || response?.user
  }
};

const actionSegments = ['register', 'edit', 'show', 'link', 'dashboard', 'register_existing', 'register_redacoes', 'show_analises', 'show_analises_objetos'];

const routeResourceMap = {
  instituicao: { type: 'faculdade', collection: 'institutions' },
  processos: { type: 'processo', collection: 'processes', registerParent: 'faculdade' },
  corretores: { type: 'corretor', collection: 'corretores', registerParent: 'faculdade' },
  fiscais: { type: 'fiscal', collection: 'fiscais', registerParent: 'faculdade' },
  avaliadores: { type: 'avaliador', collection: 'avaliadores', registerParent: 'faculdade' },
  candidatos: { type: 'candidato', collection: 'candidatos', registerParent: 'faculdade' },
  elaboradores: { type: 'professor', collection: 'elaboradores' },
  questionarios: { type: 'questionario', collection: 'questionarios' },
  membros: { type: 'membro', collection: 'membros' },
  organizadoras: { type: 'organizadora', collection: 'organizadoras' },
  demandas: { type: 'demanda', collection: 'demandas' },
  atribuicoes: { type: 'demanda', collection: 'demandas' },
  conteudo: { type: 'conteudo', collection: 'conteudos' },
  modulo: { type: 'modulo', collection: 'modulos' },
  treinamento: { type: 'treinamento', collection: 'treinamentos' },
  recursos: { type: 'recurso', collection: 'recursos' },
  disciplinas: { type: 'categoria', collection: 'disciplinas' },
  questoes: { type: 'questao', collection: 'questoes', registerParent: 'categoria' },
  questao: { type: 'questao', collection: 'questoes', registerParent: 'categoria' },
  redacoes: { type: 'redacao', collection: 'redacoes', registerParent: 'processo' },
  provas: { type: 'prova', collection: 'provas', registerParent: 'processo' },
  entrevistas: { type: 'entrevista', collection: 'entrevistas', registerParent: 'processo' },
  diagramacoes: { type: 'diagramacao', collection: 'diagramacoes', registerParent: 'processo' },
  salas: { type: 'sala', collection: 'salas' },
  questionarios_vinculados: { type: 'questionario', collection: 'questionarios_vinculados', registerParent: 'processo' },
  avaliadores_vinculados: { type: 'avaliador', collection: 'avaliadores', registerParent: 'processo' },
  candidatos_vinculados: { type: 'candidato', collection: 'candidatos', registerParent: 'processo' },
  fiscais_vinculados: { type: 'fiscal', collection: 'fiscais', registerParent: 'processo' },
  corretores_vinculados: { type: 'corretor', collection: 'corretores', registerParent: 'processo' },
  candidatos_errors: { type: 'candidatoConflito', collection: 'candidatos' }
};

const nameFromResource = (resource) => {
  if (!resource) return '';
  const value = resource.name || resource.nome || resource.nome_prova || resource.name_default || resource.title || resource.titulo || resource.email || resource.descricao;
  if (!value) return '';
  return String(value).replace(/<[^>]*>/g, '').trim();
};

const getResourceBreadcrumbName = (routeInfo, resource, labels) => {
  if (routeInfo?.type === 'questao') {
    return labels.questao;
  }

  return nameFromResource(resource);
};

const formatBreadcrumbSegment = (segment, user, t) => {
  const breadcrumbLabels = getBreadcrumbLabels(user, t);
  if (!segment) return '';
  if (/^\d+$/.test(segment)) return `#${segment}`;
  return breadcrumbLabels[segment] || segment.
  replace(/[-_]/g, ' ').
  replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const getRouteInfo = (segments) => {
  if (segments[0] === 'questoes' && segments[1] === 'chatbot' && segments[2]) {
    return {
      id: segments[2],
      action: 'chatbot',
      routeSegment: 'questoes',
      routeConfig: routeResourceMap.questoes,
      type: 'categoria'
    };
  }

  if (segments[0] === 'atribuicoes' && actionSegments.includes(segments[1]) && segments[2]) {
    return {
      id: segments[2],
      action: segments[1],
      routeSegment: 'atribuicoes',
      routeConfig: routeResourceMap.atribuicoes,
      type: 'demanda'
    };
  }

  if (segments[0] === 'questionarios_vinculados' && segments[1] === 'show' && segments[2] && segments[3]) {
    return {
      id: segments[3],
      action: null,
      routeSegment: 'questionarios_vinculados',
      routeConfig: routeResourceMap.questionarios_vinculados,
      type: 'questionario',
      fetch: async () => {
        const response = await Request.Get(`faculdade/get_questionario_vinculado/${segments[2]}/${segments[3]}`);
        return response?.questionario ? { ...response.questionario, processo: response.processo } : null;
      }
    };
  }

  if (segments[0] === 'candidatos_vinculados' && segments[1] === 'show' && segments[2] && segments[3]) {
    return {
      id: segments[2],
      action: null,
      routeSegment: 'candidatos_vinculados',
      routeConfig: routeResourceMap.candidatos_vinculados,
      type: 'candidato',
      fetch: async () => {
        const response = await Request.Get(`faculdade/get_candidato/${segments[2]}/${segments[3]}`);
        return response?.aluno || response?.candidato || null;
      }
    };
  }

  if (segments[0] === 'processos' && segments[1] === 'show_analises_objetos' && segments[3]) {
    return {
      id: segments[3],
      action: null,
      routeSegment: 'processos',
      routeConfig: routeResourceMap.processos,
      type: 'processo'
    };
  }

  const numericIndexes = segments.
  map((segment, index) => /^\d+$/.test(segment) ? index : -1).
  filter((index) => index >= 0);
  let mainIdIndex = numericIndexes[numericIndexes.length - 1];

  if (mainIdIndex == null && segments.length >= 3) {
    const possibleActionIndex = segments.length - 2;
    const possibleRouteSegment = segments[possibleActionIndex - 1];
    if (actionSegments.includes(segments[possibleActionIndex]) && routeResourceMap[possibleRouteSegment]) {
      mainIdIndex = segments.length - 1;
    }
  }

  if (mainIdIndex == null) return null;

  const actionIndex = mainIdIndex - 1;
  const action = actionSegments.includes(segments[actionIndex]) ? segments[actionIndex] : null;
  const routeSegment = action ? segments[actionIndex - 1] : segments[mainIdIndex - 1];
  const routeConfig = routeResourceMap[routeSegment];
  if (!routeConfig) return null;

  let type = routeConfig.type;
  if ((action === 'register' || action === 'register_existing' || action === 'register_redacoes') && routeConfig.registerParent) {
    type = routeConfig.registerParent;
  }

  if (routeSegment === 'organizadoras' && segments[mainIdIndex - 1] === 'membros') {
    type = action === 'register' ? 'organizadora' : 'cliente';
  }

  return {
    id: segments[mainIdIndex],
    action,
    routeSegment,
    routeConfig,
    type
  };
};

const fetchBreadcrumbResource = async (routeInfo) => {
  if (routeInfo?.fetch) return routeInfo.fetch();

  const { type, id } = routeInfo;
  const config = breadcrumbResourceConfig[type];
  if (!config || !id) return null;

  const paths = [].concat(config.path(id));
  for (let i = 0; i < paths.length; i++) {
    const response = await Request.Get(paths[i]);
    const resource = config.pick(response);
    if (resource) return resource;
  }

  return null;
};

const getParentProcess = (resource) => resource?.processo || resource?.process || null;
const getParentInstitution = (resource) => resource?.faculdade || resource?.instituicao || resource?.empresa || null;

const institutionScopedRoutes = [
'instituicao',
'processos',
'corretores',
'fiscais',
'avaliadores',
'candidatos',
'redacoes',
'provas',
'entrevistas',
'diagramacoes',
'salas',
'questionarios_vinculados',
'avaliadores_vinculados',
'candidatos_vinculados',
'fiscais_vinculados',
'corretores_vinculados',
'candidatos_errors'];


const isInstitutionScopedRoute = (routeInfo) => {
  if (!routeInfo) return false;
  if (institutionScopedRoutes.includes(routeInfo.routeSegment)) return true;
  return routeInfo.routeConfig?.registerParent === 'faculdade' || routeInfo.routeConfig?.registerParent === 'processo';
};

const getActionLabel = (action, routeSegment, user, t) => {
  const labels = getBreadcrumbLabels(user, t);
  if (routeSegment === 'atribuicoes') {
    if (action === 'register_redacoes') return t('title_essay_assignments');
    if (action === 'register') return t('title_question_assignments');
    return t('title_assignments');
  }
  if (action === 'register' || action === 'register_existing' || action === 'register_redacoes') {
    const routeConfig = routeResourceMap[routeSegment];
    if (routeSegment === 'questoes' || routeSegment === 'questao') {
      return `${t('registerAction')} ${(labels.questao || t('question')).toLowerCase()}`;
    }
    const baseLabel = routeSegment === 'processos' ? labels.process : formatBreadcrumbSegment(routeConfig?.collection || routeSegment, user, t);
    return `${t('registerAction')} ${baseLabel}`;
  }
  if (action === 'chatbot' && (routeSegment === 'questoes' || routeSegment === 'questao')) {
    return t('ui_criar_questao_com_ia_e87441a1');
  }
  if (action === 'edit' && (routeSegment === 'questoes' || routeSegment === 'questao')) {
    return `${t('edit')} ${(labels.questao || t('question')).toLowerCase()}`;
  }
  if (action === 'edit') return t('edit');
  if (action === 'link') return t('link');
  if (action === 'dashboard') return t('dashboard');
  return null;
};

const buildResolvedBreadcrumbItems = (pathname, user, resource, t) => {
  const segments = pathname.split('/').filter(Boolean);
  const labels = getBreadcrumbLabels(user, t);
  const routeInfo = getRouteInfo(segments);
  const homeLabel = user?.role === 'viwer' ? t('diagramLayouts') : labels.institutions;
  const scopedToInstitution = isInstitutionScopedRoute(routeInfo);

  if (segments.length === 0) {
    return [{ label: homeLabel, path: '/', current: true }];
  }

  if (routeInfo && !resource) {
    const actionLabel = getActionLabel(routeInfo.action, routeInfo.routeSegment, user, t);
    if (routeInfo.routeSegment === 'atribuicoes') {
      const attributionItems = [{
        label: formatBreadcrumbSegment('demandas', user, t),
        path: '/demandas',
        current: !actionLabel
      }];

      if (actionLabel) {
        attributionItems.push({ label: actionLabel, current: true });
      }

      return attributionItems.map((item, index, list) => ({
        ...item,
        current: index === list.length - 1
      }));
    }
    if (routeInfo.routeSegment === 'questoes' || routeInfo.routeSegment === 'questao') {
      const questionItems = [{
        label: formatBreadcrumbSegment('disciplinas', user, t),
        path: '/disciplinas',
        current: !actionLabel
      }];

      if (actionLabel) {
        questionItems.push({ label: actionLabel, current: true });
      }

      return questionItems.map((item, index, list) => ({
        ...item,
        current: index === list.length - 1
      }));
    }
    const items = scopedToInstitution ? [{ label: homeLabel, path: '/', current: false }] : [];
    items.push({
      label: formatBreadcrumbSegment(routeInfo.routeConfig.collection || routeInfo.routeSegment, user, t),
      current: !actionLabel
    });
    if (actionLabel) {
      items.push({ label: actionLabel, current: true });
    }
    return items.map((item, index, list) => ({
      ...item,
      current: index === list.length - 1
    }));
  }

  if (routeInfo && resource) {
    const items = scopedToInstitution ? [{ label: homeLabel, path: '/', current: false }] : [];
    const process = routeInfo.type === 'processo' ? resource : getParentProcess(resource);
    const institution = routeInfo.type === 'faculdade' ? resource : getParentInstitution(resource) || getParentInstitution(process);
    const actionLabel = getActionLabel(routeInfo.action, routeInfo.routeSegment, user, t);

    if (routeInfo.routeSegment === 'atribuicoes') {
      const attributionItems = [{
        label: formatBreadcrumbSegment('demandas', user, t),
        path: '/demandas',
        current: false
      }];

      attributionItems.push({
        label: nameFromResource(resource) || formatBreadcrumbSegment('demandas', user, t),
        path: resource.id ? `/demandas/show/${resource.id}` : null,
        current: !actionLabel
      });

      if (actionLabel) {
        attributionItems.push({ label: actionLabel, current: true });
      }

      return attributionItems.map((item, index, list) => ({
        ...item,
        current: index === list.length - 1
      }));
    }

    if (routeInfo.routeSegment === 'questoes' || routeInfo.routeSegment === 'questao') {
      const category = routeInfo.action === 'register' || routeInfo.action === 'chatbot' || routeInfo.type === 'categoria' ? resource : resource?.categoria;
      const questionItems = [{
        label: formatBreadcrumbSegment('disciplinas', user, t),
        path: '/disciplinas',
        current: false
      }];

      if (category) {
        questionItems.push({
          label: nameFromResource(category) || formatBreadcrumbSegment('disciplinas', user, t),
          path: category.id ? `/disciplinas/show/${category.id}` : null,
          current: !actionLabel
        });
      }

      if (actionLabel) {
        questionItems.push({ label: actionLabel, current: true });
      }

      return questionItems.map((item, index, list) => ({
        ...item,
        current: index === list.length - 1
      }));
    }

    if (!scopedToInstitution) {
      items.push({
        label: formatBreadcrumbSegment(routeInfo.routeConfig.collection || routeInfo.routeSegment, user, t),
        path: `/${routeInfo.routeSegment}`,
        current: false
      });
    }

    if (scopedToInstitution && institution && routeInfo.type !== 'faculdade') {
      items.push({
        label: nameFromResource(institution) || labels.institution,
        path: institution.id ? `/instituicao/show/${institution.id}` : null,
        current: false
      });
    }

    if (routeInfo.type === 'faculdade') {
      items.push({
        label: nameFromResource(resource) || labels.institution,
        path: routeInfo.action !== 'show' && resource.id ? `/instituicao/show/${resource.id}` : null,
        current: !actionLabel
      });
    } else if (scopedToInstitution && process) {
      items.push({
        label: nameFromResource(process) || labels.process,
        path: process.id ? `/processos/show/${process.id}` : null,
        current: routeInfo.type === 'processo' && !actionLabel
      });
    }

    if (routeInfo.type !== 'faculdade' && routeInfo.type !== 'processo' && !(routeInfo.type === 'questao' && actionLabel)) {
      items.push({
        label: getResourceBreadcrumbName(routeInfo, resource, labels) || formatBreadcrumbSegment(routeInfo.routeConfig.collection, user, t),
        current: !actionLabel
      });
    }

    if (actionLabel) {
      items.push({ label: actionLabel, current: true });
    }

    return items.map((item, index, list) => ({
      ...item,
      current: index === list.length - 1
    }));
  }

  const fallbackScopedRoutes = ['instituicao', 'processos', 'corretores', 'fiscais', 'avaliadores', 'candidatos'];
  const fallbackItems = segments.map((segment, index) => ({
    label: formatBreadcrumbSegment(segment, user, t),
    current: index === segments.length - 1
  }));

  if (fallbackScopedRoutes.includes(segments[0])) {
    return [
    { label: homeLabel, path: '/', current: false },
    ...fallbackItems];

  }

  return fallbackItems;
};

const GlobalBreadcrumb = ({ pathname, user }) => {const { t } = usePreferences();
  const [resource, setResource] = useState(null);

  useEffect(() => {
    let mounted = true;
    const routeInfo = getRouteInfo(pathname.split('/').filter(Boolean));

    setResource(null);
    if (!routeInfo) return undefined;

    fetchBreadcrumbResource(routeInfo).
    then((data) => {
      if (mounted) setResource(data || null);
    }).
    catch(() => {
      if (mounted) setResource(null);
    });

    return () => {
      mounted = false;
    };
  }, [pathname]);

  const items = buildResolvedBreadcrumbItems(pathname, user, resource, t);

  return (
    <nav className="modern-global-breadcrumb" aria-label="Breadcrumb">
            {items.map((item, index) =>
      <React.Fragment key={`${item.label}-${index}`}>
                    {index > 0 && <span className="breadcrumb-separator">/</span>}
                    {item.path && item.current === false ?
        <Link to={item.path}>{item.label}</Link> :

        <strong>{item.label}</strong>
        }
                </React.Fragment>
      )}
        </nav>);

};


const Home = (props) => {
  const toggled = useSelector((store) => store.AppReducer.toggled);
  const collapsed = useSelector((store) => store.AppReducer.collapsed);
  const user = useSelector((store) => store.AppReducer.user);
  const token = useSelector((store) => store.AppReducer.token);
  const adminAsUser = useSelector((store) => store.AppReducer.adminAsUser);

  const dispatch = useDispatch();
  const [loading_home, setLoadingHome] = useState(true);
  const [image, setImage] = useState(true);

  // const [toggled, setToggled] = useState(false);
  const handleCollapsedChange = (checked) => {
    dispatch(mudarDados({ collapsed: checked }));

  };

  const GetRole = async () => {
    setLoadingHome(true);
    let response = await Request.Post(`faculdade/auth/get_user`);
    if (!response) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setLoadingHome(false);

      dispatch({ type: 'logout', payload: {} });
    } else
    if (response.message == "Unauthenticated.") {
      setLoadingHome(false);

      localStorage.removeItem('token');localStorage.removeItem('user');
      dispatch({ type: 'logout', payload: {} });
      return;
    } else
    {
      dispatch({ type: 'login', payload: { token: token, user: response['user'] } });
      setLoadingHome(false);

    }

  };

  const handleImageChange = (checked) => {
    setImage(checked);
  };

  const handleToggleSidebar = (value) => {
    // setToggled(value);
    dispatch(mudarDados({ toggled: value }));
  };



  useEffect(() => {
    const event = (e) => {
      if (window.innerWidth <= 768) {
        dispatch(mudarDados({ toggled: false, collapsed: false }));

      } else
      {

        dispatch(mudarDados({ toggled: true, collapsed: true }));

      }
    };
    window.addEventListener('resize', event);
    if (window.innerWidth <= 768) {
      dispatch(mudarDados({ toggled: false, collapsed: false }));
    } else
    {
      dispatch(mudarDados({ toggled: true, collapsed: true }));
    }
    GetRole();

    return () => {
      window.removeEventListener('resize', event);

      // Anything in here is fired on component unmount.
    };
  }, []);

  const marginLeft = toggled == false || window.innerWidth <= 768 ? 0 : collapsed == false ? 270 : 80;
  console.log(props.match.url);
  return (
    <>
            {loading_home == true && <div className='d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
                <CircularProgress />
            </div>}
            {loading_home == false && <div className={`app ${toggled ? 'toggled' : ''}`}>
                <Aside
          image={image}
          collapsed={collapsed}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar}
          handleCollapsedChange={handleCollapsedChange} />


               <div
          className={`main-layout ${
          collapsed ? 'collapsed' : ''} ${

          window.innerWidth <= 768 ? 'mobile' : ''}`
          }>


                    <Header
            image={image}
            toggled={toggled}
            collapsed={collapsed}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapsedChange={handleCollapsedChange}
            handleImageChange={handleImageChange} />

                    <main className="content-area has-global-breadcrumb">
                        <div className="container-fluid">
                            <GlobalBreadcrumb pathname={props.location.pathname} user={user} />
                            {user.role == 'viwer' && <Switch>
                                <Route exact path={`${props.match.url}`} render={(props2) => <Diagramacoes {...props2} />} />
                                <Route exact path={`${props.match.url}edit_profile`} render={(props2) => <EditProfile {...props2} />} />
                            </Switch>}
                            {(user.role == 'region_admin' || user.role == 'faculdade') && <Switch>

                                <Route exact path={`${props.match.url}`} render={(props2) => <Faculdades {...props2} />} />
                                <Route exact path={`${props.match.url}instituicao/register`} render={(props2) => <CriarFaculdade {...props2} />} />
                                <Route exact path={`${props.match.url}instituicao/link/:id`} render={(props2) => <VincularInstituicao {...props2} />} />
                                <Route exact path={`${props.match.url}instituicao/dashboard/:faculdade_id`} render={(props2) => <Dashboard {...props2} />} />

                                <Route exact path={`${props.match.url}instituicao/edit/:id`} render={(props2) => <EditarFaculdade {...props2} />} />
                                <Route exact path={`${props.match.url}instituicao/show/:id`} render={(props2) => <ShowFaculdade {...props2} />} />

                                <Route exact path={`${props.match.url}processos/register/:id`} render={(props2) => <CriarProcesso {...props2} />} />

                                <Route exact path={`${props.match.url}processos/edit/:id`} render={(props2) => <EditarProcesso {...props2} />} />

                                <Route exact path={`${props.match.url}processos/show/:id`} render={(props2) => <ShowProcesso {...props2} />} />

                                <Route exact path={`${props.match.url}corretores/register/:id`} render={(props2) => <CriarCorretor {...props2} />} />
                                <Route exact path={`${props.match.url}corretores/edit/:id`} render={(props2) => <EditarCorretor {...props2} />} />

                                <Route exact path={`${props.match.url}fiscais/register/:id`} render={(props2) => <CriarFiscal {...props2} />} />
                                <Route exact path={`${props.match.url}fiscais/edit/:id`} render={(props2) => <EditarFiscal {...props2} />} />

                                <Route exact path={`${props.match.url}avaliadores/register/:id`} render={(props2) => <CriarAvaliador {...props2} />} />
                                <Route exact path={`${props.match.url}avaliadores/edit/:id`} render={(props2) => <EditarAvaliador {...props2} />} />

                                <Route exact path={`${props.match.url}candidatos/register/:id`} render={(props2) => <CriarAluno {...props2} />} />
                                <Route exact path={`${props.match.url}candidatos/edit/:id`} render={(props2) => <EditarAluno {...props2} />} />

                                {(user.role == 'region_admin' || user.empresa == null || user.empresa.hide_questionario == false) && <Route exact path={`${props.match.url}questionarios`} render={(props2) => <Questionarios {...props2} />} />}
                                {(user.role == 'region_admin' || user.empresa == null || user.empresa.hide_questionario == false) && <Route exact path={`${props.match.url}questionarios/register`} render={(props2) => <CriarQuestionario {...props2} />} />}
                                {(user.role == 'region_admin' || user.empresa == null || user.empresa.hide_questionario == false) && <Route exact path={`${props.match.url}questionarios/edit/:id`} render={(props2) => <EditarQuestionario {...props2} />} />}

                                <Route exact path={`${props.match.url}elaboradores`} render={(props2) => <Professores {...props2} />} />
                                <Route exact path={`${props.match.url}elaboradores/register`} render={(props2) => <CriarProfessor {...props2} />} />
                                <Route exact path={`${props.match.url}elaboradores/edit/:id`} render={(props2) => <EditarProfessor {...props2} />} />

                                <Route exact path={`${props.match.url}edit_profile`} render={(props2) => <EditProfile {...props2} />} />

                                {user?.empresa?.owner_id == user?.id && <Route exact path={`${props.match.url}membros/`} render={(props2) => <Membros {...props2} />} />}
                                {user?.empresa?.owner_id == user?.id && <Route exact path={`${props.match.url}membros/register/`} render={(props2) => <CriarMembro {...props2} />} />}
                                {user?.empresa?.owner_id == user?.id && <Route exact path={`${props.match.url}membros/edit/:id`} render={(props2) => <EditarMembro {...props2} />} />}


                                {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras`} render={(props2) => <Organizadoras {...props2} />} />}
                                {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/register`} render={(props2) => <CriarOrganizadora {...props2} />} />}
                                {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/edit/:id`} render={(props2) => <EditarOrganizadora {...props2} />} />}


                                {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/membros/:id`} render={(props2) => <Clientes {...props2} />} />}
                                {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/membros/register/:id`} render={(props2) => <CriarCliente {...props2} />} />}
                                {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/membros/edit/:id`} render={(props2) => <EditarCliente {...props2} />} />}


                                <Route exact path={`${props.match.url}demandas`} render={(props2) => <Demandas {...props2} />} />
                                <Route exact path={`${props.match.url}demandas/register`} render={(props2) => <CriarDemanda {...props2} />} />
                                <Route exact path={`${props.match.url}demandas/edit/:id`} render={(props2) => <EditarDemanda {...props2} />} />
                                <Route exact path={`${props.match.url}demandas/show/:id`} render={(props2) => <ShowDemanda {...props2} />} />
                                <Route exact path={`${props.match.url}atribuicoes/register/:id`} render={(props2) => <CriarAtribuicoes {...props2} />} />
                                <Route exact path={`${props.match.url}atribuicoes/register_redacoes/:id`} render={(props2) => <CriarAtribuicoesRedacao {...props2} />} />

                                <Route exact path={`${props.match.url}conteudos`} render={(props2) => <Conteudos {...props2} />} />
                                <Route exact path={`${props.match.url}conteudo/register`} render={(props2) => <CriarConteudo {...props2} />} />
                                <Route exact path={`${props.match.url}conteudo/edit/:id`} render={(props2) => <EditarConteudo {...props2} />} />
                                <Route exact path={`${props.match.url}conteudo/show/:id`} render={(props2) => <ShowConteudo {...props2} />} />

                                <Route exact path={`${props.match.url}conteudo/questao/register/:id`} render={(props2) => <CriarQuestaoConteudo {...props2} />} />
                                <Route exact path={`${props.match.url}conteudo/questao/edit/:id`} render={(props2) => <EditarQuestaoConteudo {...props2} />} />


                                <Route exact path={`${props.match.url}modulos`} render={(props2) => <Modulos {...props2} />} />
                                <Route exact path={`${props.match.url}modulo/register`} render={(props2) => <CriarModulo {...props2} />} />
                                <Route exact path={`${props.match.url}modulo/edit/:id`} render={(props2) => <EditarModulo {...props2} />} />
                                <Route exact path={`${props.match.url}modulo/show/:id`} render={(props2) => <ShowModulo {...props2} />} />


                                {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamentos`} render={(props2) => <Treinamentos {...props2} />} />}
                                {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamentos/register`} render={(props2) => <CriarTreinamento {...props2} />} />}
                                {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamento/edit/:id`} render={(props2) => <EditarTreinamento {...props2} />} />}
                                {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamento/show/:id`} render={(props2) => <ShowTreinamento {...props2} />} />}
                                {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamento/dashboard/:id`} render={(props2) => <DashboardTreinamento {...props2} />} />}

                                <Route exact path={`${props.match.url}redacoes/show/:id`} render={(props2) => <ShowRedacoesProcesso {...props2} />} />

                                <Route exact path={`${props.match.url}atribuicoes/show/:demanda_id`} render={(props2) => <QuestoesDemanda {...props2} />} />


                                <Route exact path={`${props.match.url}recursos`} render={(props2) => <Recursos {...props2} />} />
                                <Route exact path={`${props.match.url}recursos/register`} render={(props2) => <CriarRecurso {...props2} />} />
                                <Route exact path={`${props.match.url}recursos/edit/:id`} render={(props2) => <EditarRecurso {...props2} />} />
                                <Route exact path={`${props.match.url}recursos/show/:id`} render={(props2) => <ShowRecurso {...props2} />} />


                                <Route exact path={`${props.match.url}avaliar-questoes`} render={(props2) => <AvaliarQuestoes {...props2} />} />
                                <Route exact path={`${props.match.url}avaliar-questoes/show/:id`} render={(props2) => <ShowAvaliarQuestoes {...props2} />} />




                                <Route exact path={`${props.match.url}disciplinas`} render={(props2) => <CategoriasQuestoes {...props2} />} />
                                <Route exact path={`${props.match.url}disciplinas/register`} render={(props2) => <CriarCategoria {...props2} />} />
                                <Route exact path={`${props.match.url}disciplinas/edit/:id`} render={(props2) => <EditarCategoria {...props2} />} />

                                <Route exact path={`${props.match.url}disciplinas/show/:id`} render={(props2) => <Questoes {...props2} />} />
                                <Route exact path={`${props.match.url}questoes/register/:id`} render={(props2) => <CriarQuestao {...props2} />} />
                                <Route exact path={`${props.match.url}questoes/edit/:id`} render={(props2) => <EditarQuestao {...props2} />} />

                                {user?.empresa?.plan?.question_ia && <Route exact path={`${props.match.url}questoes/chatbot/:id`} render={(props2) => <ChatBotQuestao {...props2} />} />}


                                <Route exact path={`${props.match.url}banca-questoes`} render={(props2) => <BancaQuestoes {...props2} />} />


                                <Route exact path={`${props.match.url}redacoes/register/:id`} render={(props2) => <CriarRedacao {...props2} />} />
                                <Route exact path={`${props.match.url}redacoes/edit/:id`} render={(props2) => <EditarRedacao {...props2} />} />

                                <Route exact path={`${props.match.url}provas/register/:id`} render={(props2) => <CriarProva {...props2} />} />
                                <Route exact path={`${props.match.url}provas/register_existing/:id`} render={(props2) => <CriarProvaExistente {...props2} />} />


                                <Route exact path={`${props.match.url}provas/edit/:id`} render={(props2) => <EditarProva {...props2} />} />

                                <Route exact path={`${props.match.url}entrevistas/register/:id`} render={(props2) => <CriarEntrevista {...props2} />} />
                                <Route exact path={`${props.match.url}entrevistas/edit/:id`} render={(props2) => <EditarEntrevista {...props2} />} />
                                <Route exact path={`${props.match.url}entrevistas/show/:id`} render={(props2) => <ShowEntrevista {...props2} />} />



                                <Route exact path={`${props.match.url}diagramacoes/register/:id`} render={(props2) => <CriarDiagramacao {...props2} />} />
                                <Route exact path={`${props.match.url}diagramacoes/edit/:id`} render={(props2) => <EditarDiagramacao {...props2} />} />

                                <Route exact path={`${props.match.url}questionarios_vinculados/register/:id`} render={(props2) => <CriarQuestionarioVinculado {...props2} />} />
                                <Route exact path={`${props.match.url}questionarios_vinculados/show/:processo_id/:questionario_id`} render={(props2) => <ShowQuestionarioProcesso {...props2} />} />

                                <Route exact path={`${props.match.url}avaliadores_vinculados/register/:id`} render={(props2) => <CriarAvaliadorVinculado {...props2} />} />

                                <Route exact path={`${props.match.url}candidatos_vinculados/show/:id/:processo_id`} render={(props2) => <ShowCandidato {...props2} />} />

                                <Route exact path={`${props.match.url}candidatos_vinculados/register/:id`} render={(props2) => <CriarCandidatoVinculado {...props2} />} />

                                <Route exact path={`${props.match.url}fiscais_vinculados/register/:id`} render={(props2) => <CriarFiscalVinculado {...props2} />} />
                                <Route exact path={`${props.match.url}corretores_vinculados/register/:id`} render={(props2) => <CriarCorretorVinculado {...props2} />} />

                                <Route exact path={`${props.match.url}salas/show/:id`} render={(props2) => <ShowSala {...props2} />} />



                                <Route exact path={`${props.match.url}provas/show/:id`} render={(props2) => <ShowProvasProcesso {...props2} />} />
                                <Route exact path={`${props.match.url}diagramacoes/show/:id`} render={(props2) => <ShowDiagramacao {...props2} />} />

                                <Route exact path={`${props.match.url}system`} render={(props2) => <ModulosSistema {...props2} />} />


                                <Route exact path={`${props.match.url}candidatos_errors/edit/:id`} render={(props2) => <EditarCandidatoConflito {...props2} />} />


                                <Route exact path={`${props.match.url}processos/show_analises/:id`} render={(props2) => <ShowAnalise {...props2} />} />
                                <Route exact path={`${props.match.url}processos/show_analises_objetos/:id/:processo_id`} render={(props2) => <ShowAnaliseObjeto {...props2} />} />


                            </Switch>}
                        </div>
                    </main>
                </div>


            </div>}
        </>);


};

export default Home;
